export const BillingDiscountsColumns = [
    {
        name: 'Сумма скидки',
        key: 'amount',
    },
    {
        name: 'Статус',
        key: 'status'
    },
    {
        name: 'Выдана на',
        key: 'entityType'
    },
    {
        name: 'Дата окончания',
        key: 'expiredAt'
    },
]
